import type { ChainId } from '@morpho-org/blue-sdk'

export interface DashboardEarnPositionsFilters {
  assetIdsFilter: string[]
  chainIdsFilter: ChainId[]
}

export interface DashboardBorrowPositionsFilters {
  collateralAssetIdsFilter: string[]
  loanAssetIdsFilter: string[]
  chainIdsFilter: ChainId[]
}

export interface DashboardLendPositionsFilters {
  collateralAssetIdsFilter: string[]
  loanAssetIdsFilter: string[]
  chainIdsFilter: ChainId[]
}

export interface DashboardActivityFilters {
  chainIdsFilter: ChainId[]
  typeFilter: string[]
  searchFilter: string
}

export enum AssetFilter {
  ALL = 'all',
  STABLECOIN = 'stablecoin',
  ETH = 'eth',
  BTC = 'btc',
  PT = 'pt',
  STOCKS = 'stocks'
}
